<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre" id="i_005">
<img alt="The author" class="calibre6" id="id-3528274656142571656" src="Images/img0001.jpg"/>
<div class="caption figcaption">John L. Ransom.<br/>
(From a photograph taken two months before capture.)</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?1e4e8871